import { Component } from 'react';
import Router from 'next/router';
import {
  calculateSipFutureValue,
  formatRupeeLiteral,
  calculateLumpsumFutureValue,
} from '../constants';
// import Button from '../components/ui/button';
import Field from './ui/field';
import styles from '../styles/amcs.scss';

class SipCalculatorNew extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      timePeriod: 20,
      investmentAmount: 4000,
      fundTypeRate: 14,
      showResult: true,
      interestRate: null,
      selectedCalc: 'monthly',
    };
  }

  public componentDidMount() {
    // const { onlySipCalculator } = this.props;
    // if (!onlySipCalculator) {
    //   this.loadChart();
    // }
    this.setInterestRate();
    // this.loadChart();
  }

  public UNSAFE_componentWillReceiveProps(nextProps: any) {
    const { investmentType, amount } = nextProps;
    const prevInvestmentType = this.props.investmentType;
    const prevAmount = this.props.amount;
    if (investmentType !== prevInvestmentType) {
      this.setState({
        investmentType,
      });
    }
    if (amount !== prevAmount) {
      this.setState({
        investmentAmount: amount,
      });
    }
  }

  public handlePeriodChange = (e: any) => {
    let { value } = e.target;
    const { showResult } = this.state;
    if (value > 30) {
      e.preventDefault();
      value = 30;
    }
    if (value < 1) {
      e.preventDefault();
      value = 1;
    }
    this.setState(
      {
        timePeriod: value,
      },
      () => {
        if (showResult) {
          this.setInterestRate();
        }
      }
    );
  };

  public setInterestRate = () => {
    const { returns, categoryDetails } = this.props;
    const { timePeriod, fundTypeRate } = this.state;
    const {
      return1yr,
      return2yr,
      return3yr,
      return4yr,
      return5yr,
      return6yr,
      return7yr,
      return8yr,
      return9yr,
      return10yr,
      returnSinceInception,
    } = returns;
    const {
      return1yr: categoryReturn1yr,
      return3yr: categoryReturn3yr,
      return5yr: categoryReturn5yr,
      return10yr: categoryReturn10yr,
    } = categoryDetails;
    let interest;
    switch (true) {
      case Number(timePeriod) === 1:
        interest = return1yr || categoryReturn1yr;
        break;
      case Number(timePeriod) === 2:
        interest = return2yr || return1yr;
        break;
      case Number(timePeriod) === 3:
        interest = return3yr || categoryReturn3yr || return1yr;
        break;
      case Number(timePeriod) === 4:
        interest = return4yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 5:
        interest =
          return5yr ||
          categoryReturn5yr ||
          return3yr ||
          categoryReturn3yr ||
          return1yr;
        break;
      case Number(timePeriod) === 6:
        interest =
          return6yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 7:
        interest =
          return7yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 8:
        interest =
          return8yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 9:
        interest =
          return9yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 10:
        interest =
          return10yr ||
          categoryReturn10yr ||
          return5yr ||
          return3yr ||
          categoryReturn3yr ||
          return1yr;
        break;
      case Number(timePeriod) > 10:
        interest =
          returnSinceInception ||
          return10yr ||
          categoryReturn10yr ||
          return5yr ||
          categoryReturn5yr;
        break;
      default:
        interest = return5yr || fundTypeRate;
    }
    this.setState({ interestRate: interest });
  };

  public handleAmountChange = (e: any) => {
    const { value } = e.target;
    let investmentAmount = parseInt(value.replace('Rs. ', ''), 10) || 0;
    if (investmentAmount > 1000000) {
      e.preventDefault();
      investmentAmount = 1000000;
    }
    if (investmentAmount < 500) {
      e.preventDefault();
      investmentAmount = 500;
    }
    this.setState({
      investmentAmount,
    });
  };
  public handleFundTypeChange = (e: any) => {
    this.setState({
      fundTypeRate: e.target.value,
    });
  };
  // public handleCalculate = () => {
  //   this.loadChart();
  //   Router.pushRoute('/save/sip-calculator#result');
  //   this.setState({
  //     showResult: true,
  //   });
  // };
  public sipResult = () => {
    const {
      investmentAmount,
      timePeriod,
      interestRate,
      selectedCalc,
    } = this.state;
    const invAmount = investmentAmount;
    if (selectedCalc === 'onetime') {
      return (
        <div className="lil-text-center">
          <span className="lil-font-semibold">{`₹${formatRupeeLiteral(
            invAmount
          )}`}</span>{' '}
          invested one time becomes{' '}
          <span
            className={`lil-text-s-20 lil-font-semibold ${styles['text-green']}`}
          >
            ₹{''}
            {formatRupeeLiteral(
              calculateLumpsumFutureValue(invAmount, timePeriod, interestRate)
            )}
          </span>{' '}
          in a period of{' '}
          <span className="lil-font-semibold">{` ${timePeriod} years`}</span>
        </div>
      );
    }
    return (
      <div className="lil-text-center">
        <span className="lil-font-semibold">{`₹${formatRupeeLiteral(
          invAmount
        )}`}</span>{' '}
        <span className="lil-font-medium">invested monthly becomes </span>
        <span
          className={`lil-text-s-20 lil-font-semibold ${styles['text-green']}`}
        >
          ₹{''}
          {formatRupeeLiteral(
            calculateSipFutureValue(invAmount, timePeriod, interestRate)
          )}
        </span>{' '}
        <span className="lil-font-medium">in a period of </span>
        <span className="lil-font-semibold">{` ${timePeriod} years`}</span>
      </div>
    );
  };
  public getResult = () => {
    return <div className="lil-pt-4">{this.sipResult()}</div>;
  };

  public switchBtn(id: string) {
    this.setState({
      selectedCalc: id,
    });
  }

  public render() {
    const { timePeriod, investmentAmount, selectedCalc } = this.state;
    const minDurationSliderValue = 1;
    const maxDurationSliderValue = 30;
    const minAmountSliderValue = 500;
    const maxAmountSliderValue = 1000000;

    return (
      <div>
        <div className="lil-flex lil-justify-center">
          <div
            id="switchBtnHolder1"
            onClick={() => this.switchBtn('monthly')}
            className={`lil-w-1/4 lil-text-center lil-border-b-lg lil-cursor-pointer lil-font-semibold lil-pb-2 sm:lil-w-1/2
                                ${
                                  selectedCalc === 'monthly'
                                    ? `${styles['border-blue-250']} `
                                    : 'lil-border-grey-250 '
                                }`}
          >
            Monthly (SIP)
          </div>
          <div
            id="switchBtnHolder2"
            onClick={() => this.switchBtn('onetime')}
            className={`lil-w-1/4 lil-text-center lil-border-b-lg lil-cursor-pointer lil-font-semibold lil-pb-2 sm:lil-w-1/2
                                ${
                                  selectedCalc === 'onetime'
                                    ? `${styles['border-blue-250']} `
                                    : 'lil-border-grey-250 '
                                }`}
          >
            One-Time
          </div>
        </div>

        <div className="lil-pt-12">
          <div className="lil-flex lil-items-center sm:lil-relative">
            <div className="lil-w-5/6 lil-pr-6 sm:lil-w-full sm:lil-pr-0">
              <Field
                value={investmentAmount}
                name="amount"
                id="investmentAmount"
                type="slider"
                labelStyles="lil-text-font-500 lil-font-semibold"
                minSliderValue={minAmountSliderValue}
                maxSliderValue={maxAmountSliderValue}
                className="lil-w-full "
                labelName="Amount"
                sliderStep="500"
                onChange={this.handleAmountChange}
              />
            </div>
            <span className="lil-text-s-18 lil-absolute lil-top-0 lil-right-0 lil-pr-4 lil-font-semibold md-lil-hidden xl:lil-hidden lg:lil-hidden">
              ₹{investmentAmount}
            </span>
            <div className="lil-flex lil-items-center lil-w-1/6 sm:lil-hidden">
              <span className="lil-flex lil-items-center lil-font-semibold lil-border-sm lil-w-11/12 lil-rounded-xl lil-border-grey-250 lil-py-2 lil-pl-4 lil-pr-2 lil-text-right">
                <input
                  value={investmentAmount}
                  name="amountTextNew"
                  id="investmentAmountText"
                  type="text"
                  max={maxAmountSliderValue}
                  min={minAmountSliderValue}
                  className="lil-border-none lil-text-blue-350 lil-text-right"
                  onChange={this.handleAmountChange}
                />
              </span>
              <span className="lil-font-medium lil-pl-2 lil-text-font-200 lil-w-1/12">
                ₹
              </span>
            </div>
          </div>
          <div className="lil-flex lil-items-center lil-mt-8 sm:lil-relative">
            <div className="lil-w-5/6 lil-pr-6 sm:lil-w-full">
              <Field
                value={timePeriod}
                name="Investment time"
                id="durationSlider"
                type="slider"
                minSliderValue={minDurationSliderValue}
                maxSliderValue={maxDurationSliderValue}
                labelName="Investment Duration(Years)"
                className="lil-w-full"
                onChange={this.handlePeriodChange}
                sliderStep="1"
                labelStyles={'mb20'}
              />
            </div>
            <span className="lil-text-s-18 lil-absolute lil-top-0 lil-right-0 lil-pr-4 lil-font-semibold md-lil-hidden xl:lil-hidden lg:lil-hidden">
              {timePeriod}
            </span>
            <div className="lil-w-1/6 lil-flex lil-items-center sm:lil-hidden">
              <span className="lil-text-blue-350 lil-font-semibold lil-border-sm lil-rounded-xl lil-border-grey-250 lil-py-2 lil-pl-2 lil-pr-2 lil-text-right">
                <input
                  value={timePeriod}
                  name="amountTextNew"
                  id="timePeriodText"
                  type="text"
                  max={maxDurationSliderValue}
                  min={minDurationSliderValue}
                  style={{ width: '50px' }}
                  className="lil-border-none lil-text-blue-350 lil-text-center"
                  onChange={this.handlePeriodChange}
                />
              </span>
              <span className="lil-pl-2 lil-text-font-200 lil-font-semibold">
                yrs
              </span>
            </div>
          </div>
          {this.getResult()}
          <div className="lil-text-center lil-mt-6">
            <button
              className="lil-btn lil-btn-blue"
              onClick={() => Router.pushRoute('/s/sip')}
            >
              View our best SIP plans
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SipCalculatorNew;



// WEBPACK FOOTER //
// ./components/sipCalculatorNew.tsx